import React from 'react';
import EssentialsInfo from '../components/plan-info/EssentialsInfo';
import InfoPage from '../components/plan-info/InfoPage';

const essentialsInfoBasic = () => {
    return (
        <InfoPage className="InfoPage-essentials">
            <EssentialsInfo />
        </InfoPage>
    );
};

export default essentialsInfoBasic;
